import Immutable from 'immutable';
import { getFilters } from "../config/filters";
import { DISJUNCTIVE_FACET_TYPE } from "../records/FacetType";

const multiFilters = featureFlags => getFilters({
  featureFlags
}).filter(f => f.get('type') === DISJUNCTIVE_FACET_TYPE).map(f => f.get('key'));

const baseFilters = featureFlags => multiFilters(featureFlags).reduce((r, q) => r.set(q, Immutable.Set()), Immutable.Map());

export default function enhanceFilters(filters, featureFlags = {}) {
  return baseFilters(featureFlags).merge(filters.filter(q => q)).map((v, k) => {
    if (multiFilters(featureFlags).includes(k)) {
      if (Immutable.Iterable.isIterable(v)) {
        return v.toSet();
      } else {
        return Immutable.Set([v]);
      }
    }

    return v;
  });
}